import { render, staticRenderFns } from "./AddUpdateNew.vue?vue&type=template&id=6ed143a6&scoped=true&"
import script from "./AddUpdateNew.vue?vue&type=script&lang=js&"
export * from "./AddUpdateNew.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateNew.vue?vue&type=style&index=0&id=6ed143a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed143a6",
  null
  
)

export default component.exports